export default class Receipt {

}



// WEBPACK FOOTER //
// ./src/ressources/Receipt.js